import { useEffect, useState } from "react";
import style from "./CopyElement.module.scss";
import cn from "classnames";

export function CopyElement({
    element,
    copyText,
    alignCopyButton = "right"
}: {
    element: JSX.Element,
    copyText: string,
    alignCopyButton?: "left" | "right"
}) {
    const [status, setStatus] = useState<"success" | "error" | "idle">("idle");

    useEffect(() => {
        if ((status === "success") || (status === "error")) {
            setTimeout(() => {
                setStatus("idle")
            }, 2000);
        }
    }, [status])

    return (
        <div className={cn(
            style.container,
            style["align_" + alignCopyButton]
        )}>
            <div className={style.element}>
                {element}
            </div>
            <button
                type="button"
                className={cn(
                    style.copyButton,
                    style["status_" + status]
                )}
                onClick={() => {
                    navigator.clipboard.writeText(copyText)
                        .then(() => {
                            setStatus("success");
                        })
                        .catch(() => {
                            setStatus("error");
                        });
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                    <path d="M9.87688 7.58441V10.3144C9.87688 12.5894 8.98919 13.4994 6.76997 13.4994H4.10691C1.88769 13.4994 1 12.5894 1 10.3144V7.58441C1 5.30941 1.88769 4.39941 4.10691 4.39941H6.76997C8.98919 4.39941 9.87688 5.30941 9.87688 7.58441Z" stroke="#1b1b1d" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13.6818 3.685V6.415C13.6818 8.69 12.7941 9.6 10.5749 9.6H9.87743V7.585C9.87743 5.31 8.98975 4.4 6.77053 4.4H4.80493V3.685C4.80493 1.41 5.69262 0.5 7.91184 0.5H10.5749C12.7941 0.5 13.6818 1.41 13.6818 3.685Z" stroke="#1b1b1d" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </div>
    )
}